import { PICTURE_COMPREHENSION_RECOGNITION_MESSAGES } from '../../../../constants/picture-comprehension.ts';

import { getTaskPictureUtil } from '../../../managers/task-picture.util.ts';

import { BaseAskToTapStateChangeHandlerUtil } from './base-ask-to-tap.handler.ts';

/**
 * Specialized handler for picture comprehension tap interaction
 */
export class PictureAskToTapStateChangeHandlerUtil extends BaseAskToTapStateChangeHandlerUtil {
  private static _instance: PictureAskToTapStateChangeHandlerUtil;

  public static get instance(): PictureAskToTapStateChangeHandlerUtil {
    if (!PictureAskToTapStateChangeHandlerUtil._instance) {
      PictureAskToTapStateChangeHandlerUtil._instance = new PictureAskToTapStateChangeHandlerUtil();
    }
    return PictureAskToTapStateChangeHandlerUtil._instance;
  }

  private constructor(private readonly taskPictureUtil = getTaskPictureUtil()) {
    super();
  }

  protected getHandlerName(): string {
    return 'PictureAskToTap';
  }

  /**
   * Waits for a picture element to be clicked
   */
  protected async waitForTapInteraction(): Promise<string> {
    return await this.taskPictureUtil.waitForClick();
  }

  /**
   * Validates if the tap interaction was successful
   * For picture comprehension, the taskPictureUtil already validates
   * and returns a predetermined result message
   */
  protected async validateTap(tappedResult: string): Promise<boolean> {
    return Promise.resolve(tappedResult === PICTURE_COMPREHENSION_RECOGNITION_MESSAGES.CORRECT);
  }
}

export const getPictureAskToTapStateChangeHandlerUtil = (): PictureAskToTapStateChangeHandlerUtil =>
  PictureAskToTapStateChangeHandlerUtil.instance;
